import { render, staticRenderFns } from "./MyPQPage.vue?vue&type=template&id=05a1196a&"
import script from "./MyPQPage.vue?vue&type=script&lang=js&"
export * from "./MyPQPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports